import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { JardinModel } from 'src/app/model/Jardin.model';
import { EstrategiaModel, PlanGestionConvivenciaModel, ResponsePlanGestionConvivencia } from 'src/app/model/PlanGestionConvivencia.model';
import { apiService } from 'src/app/service/api.service';
import { PlanGestionConvivenciaService } from 'src/app/service/planGestionConvidencia.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { PreviewComponent } from 'src/app/components/preview/preview.component';

@Component({
  selector: 'app-plan-gestion-convivencia',
  templateUrl: './plan-gestion-convivencia.component.html',
  styleUrls: ['./plan-gestion-convivencia.component.css']
})
export class PlanGestionConvivenciaComponent implements OnInit {

  @Input() simulacion: boolean;
  @ViewChild('modalInforme', { static: true }) modalInforme: TemplateRef<any>;
  dataJardin = new JardinModel();
  planGestionConvivenciaModel = new PlanGestionConvivenciaModel();
  public isCollapsed1 = true;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  apiEndpoint = environment.apiEndpoint;

  url:string ;
  urlSafe: SafeResourceUrl;
  @Input() index : number;
  @Input() readonly : boolean;
  public isCollapsed = true;
  
  constructor(
    public dialog: MatDialog,
    private api: apiService,
    public spinner: NgxSpinnerService,
    private modal: NgbModal,
    private planGestionConvivenciaService: PlanGestionConvivenciaService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.dataJardin = this.api.dataJardin;
    this.getPlanGestionConvivencia();
  }

  getPlanGestionConvivencia(){
    this.planGestionConvivenciaService.API_GET_getPlanGestionConvivencia(this.dataJardin.idJardinPeriodo).subscribe((response: ResponsePlanGestionConvivencia) => {
      this.planGestionConvivenciaModel = response.payload;  
      this.spinner.hide();
    },
    (err) => {
      this.spinner.hide();
      console.log(err);
    });      
  }

  agregarEstrategia(){
    this.spinner.show();
    if( this.planGestionConvivenciaModel.estrategias.length <= 4 ){
      this.planGestionConvivenciaModel.estrategias.push(new EstrategiaModel());
    }
    this.spinner.hide();
  }

  guardar(){
    this.spinner.show();
    this.planGestionConvivenciaService.API_POST_savePlanGestionConvivencia(this.dataJardin.idJardinPeriodo, this.planGestionConvivenciaModel).subscribe((response: ResponsePlanGestionConvivencia) => {
      this.planGestionConvivenciaModel = response.payload;  
      this.spinner.hide();
    },
    (err) => {
      this.spinner.hide();
      console.log(err);
    });     
  }

 /* imprimir(){
    this.url = this.apiEndpoint + "planGestionConvivencia/imprimir/" + this.dataJardin.idJardinPeriodo;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.modal.open(this.modalInforme, { size: 'xl' });
  }*/

  close(){
    this.modal.dismissAll();
  }

  enviar(){
    if(this.planCompleto()){
      Swal.fire({
        title: '¿desea enviar?',
        text: 'Se realizará el envío del Plan de Gestión de Convivencia dejando esta como fecha de Elaboración. ',
        icon: 'question',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();
          this.planGestionConvivenciaService.API_PUT_enviarPlanGestionConvivencia(this.dataJardin.idJardinPeriodo, this.planGestionConvivenciaModel).subscribe((response: ResponsePlanGestionConvivencia) => {
            this.planGestionConvivenciaModel = response.payload;  
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            console.log(err);
          });    
        }
      });
    }
  }

  planCompleto(): boolean{
    var planCompleto = true;

    if(this.planGestionConvivenciaModel.diagnostico != ""){
      planCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe llenar los datos de Diagnostico',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    if (this.planGestionConvivenciaModel.estrategias.length >= 3 && this.planGestionConvivenciaModel.estrategias.length <= 4) {
      for (let i = 0; i < this.planGestionConvivenciaModel.estrategias.length; i++) {
        const estrategia = this.planGestionConvivenciaModel.estrategias[i];
        if (estrategia.estrategia === "") {
          Swal.fire({
            title: 'Faltan campos que completar',
            text: 'Debe completar las descripciones de la estrategia ' + (i +1) + ' .',
            icon: 'info',
            confirmButtonText: 'OK'
          });

        }
        if (estrategia.actividades.length >= 1 && estrategia.actividades.length <= 5) {
          //validar al menos una estrategia completa por actividad
          let numeroActividades = estrategia.actividades.length;
          for (let x = 0; x < estrategia.actividades.length; x++) {
            const actividad = estrategia.actividades[x];
            if (actividad.actividad  === "" || actividad.objetivo === "" || actividad.descripcion === "" || actividad.lugar === "" 
                || actividad.responsable === "" || actividad.medioVerificacion === "" || actividad.fechaDesde === null || actividad.fechaHasta === null
                || actividad.fechaDesde === undefined || actividad.fechaHasta === undefined ) {
                  
                  Swal.fire({
                    title: 'Faltan campos que completar en las actividades',
                    text: 'Para envíar debe completar todos los datos de al menos una actividad por estrategia y/o no dejar la actividad 1 en blanco u otras actividades a medio completar.',
                    icon: 'info',
                    confirmButtonText: 'OK'
                  });
        
                  return false;
            }

            if(this.validarFechas(actividad.fechaDesde , actividad.fechaHasta )==1){
                Swal.fire({
                  title: 'Fechas mal ingresadas',
                  text: 'No puede ingresar en la fecha hasta una anterior a la fecha desde',
                  icon: 'info',
                  confirmButtonText: 'OK'
                });
                return false;
              }else if(this.validarFechas(actividad.fechaDesde , actividad.fechaHasta )==2){
                Swal.fire({
                  title: 'Fechas mal ingresadas',
                  text: 'No puede ingresar fechas de un año distinto al actual.',
                  icon: 'info',
                  confirmButtonText: 'OK'
                });
                return false;
              }
          }

        /*  if(numeroActividades === 0){
            Swal.fire({
              title: 'Faltan campos que completar en las actividades',
              text: 'Para envíar debe completar todos los datos de al menos una actividad por estrategia.',
              icon: 'info',
              confirmButtonText: 'OK'
            });
  
            return false;
          }*/
          planCompleto = true;
        } else {
          Swal.fire({
            title: 'Faltan Actividades',
            text: 'Para envíar debe completar Mínimo 1 máximo 5 Actividades por Estrategia',
            icon: 'info',
            confirmButtonText: 'OK'
          });

          return false;
        }
      }
    } else {
      Swal.fire({
        title: 'Faltan Estrategias',
        text: 'Para envíar debe competar Mínimo 3 máximo 4 Estrategias',
        icon: 'info',
        confirmButtonText: 'OK'
      });
      return false;
    }

    if(this.planGestionConvivenciaModel.responsable != ""){
      planCompleto = true;
    }else {
      Swal.fire({
        title: 'Faltan Datos',
        text: 'Para envíar debe completar el/la responsable del seguimiento',
        icon: 'info',
        confirmButtonText: 'OK'
      });

      return false;
    }

    return planCompleto;
  }

    public verArchivo(path : string, realName : string): void {
  
        const dialogRef = this.dialog.open(PreviewComponent, {
        disableClose: true,
            data: {file: path, name: realName }
        });
    }


    verDocumento(){
      this.url = this.apiEndpoint + "planGestionConvivencia/imprimir/" + this.dataJardin.idJardinPeriodo;
        this.verArchivo(this.url,'planGestionConvivencia.pdf');
      }

      validarFechas(fechaDesde:Date, fechaHasta:Date){

          var fechaInicio  = {"day": fechaDesde.getDate(), "month": fechaDesde.getMonth() + 1, "year": fechaDesde.getFullYear()};

          var fechaFin  = {"year": fechaHasta.getFullYear(),"month": fechaHasta.getMonth() + 1, "day": fechaHasta.getDate()};

            if (fechaHasta.getTime() - fechaDesde.getTime() < 0) {
              return 1;
            } 
        
            if(fechaInicio.year != 2026 || fechaFin.year != 2026){
              return 2;
            } 
            
            return 0;
      }
}
